export default {
  no_results: {
    title: 'Ei tuloksia haulle "{{search}}"',
    desc: 'Valitettavasti emme löytäneet vastaavuutta. Kokeile toista hakusanaa.',
  },
  empty_menu: {
    title: 'Ei vielä saatavilla olevia tuotteita',
    desc: 'Tässä valikossa ei ole tällä hetkellä mitään näytettävää. Tarkista pian uudelleen.',
  },
};
